import { AntDesign } from "@expo/vector-icons";
import { BlurView } from "expo-blur";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { View, Modal, Pressable, TextInput } from "react-native";

import SecurityImage from "@/assets/encryption.svg";
import Subtitle from "@/components/Subtitle";
import Title from "@/components/Title";
import Button from "@/components/button/Button";

interface SecurityModalProps {
  visible: boolean;
  onClick?: (state: boolean) => void;
  onClose: () => void;
  hasChanged?: (state: boolean) => void;
  sendCode?: (code: string) => void;
  email?: string;
  password?: string;
}

export default function SecurityModal(props: SecurityModalProps) {
  const [code, setCode] = useState("");

  const { t } = useTranslation();

  return (
    <Modal visible={props.visible} transparent animationType="fade">
      <BlurView intensity={20} className="flex-1 justify-center items-center">
        <View className="p-6 bg-white1 border border-gray rounded-lg w-full h-full items-center justify-center shadow relative lg:w-104 lg:h-136 lg:justify-start">
          <Pressable className="absolute right-3 top-3" onPress={props.onClose}>
            <AntDesign name="close" size={24} color="black" />
          </Pressable>
          <View className="flex-grow items-center justify-center lg:justify-start">
            <View className="m-2">
              <Title text={t("common:modal.2fa.title")} />
            </View>
            <View className="m-1">
              <Subtitle text={t("common:modal.2fa.subtitle")} />
            </View>
            <View className="w-full items-center px-4 py-10">
              <SecurityImage width={160} height={120} />
              <TextInput
                className="border-2 rounded border-lightgray text-3xl font-light bg-white1 text-center py-2 my-4"
                value={code}
                placeholder={t("validate:placeholder")}
                placeholderTextColor="#DFDFDF"
                onChangeText={(text) => {
                  const filteredText = text.replace(/\D/g, "");
                  setCode(filteredText);
                }}
                keyboardType="numeric"
              />
            </View>
          </View>
          <Button
            label={t("common:button.confirm")}
            onClick={() => props.sendCode(code)}
          />
        </View>
      </BlurView>
    </Modal>
  );
}
